import { useState, Fragment } from 'react';
import { DataCard } from '@/reports/shared/DataCard/DataCard';
import { AutomobileAuction } from '@/reports/types/vehicles';
import { Stack, useMediaQuery, useTheme } from '@/theme/index';
import {
  CardAuctionDetails,
  CardTitleDetails,
  ModalContent,
  StyledDivider,
  StyledModal,
} from './components';

interface VehicleAuctionCardProps {
  auction: AutomobileAuction;
  vehicleYMM: string;
}

export function VehicleAuctionCard({
  auction,
  vehicleYMM,
}: VehicleAuctionCardProps) {
  const [openModal, setOpenModal] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  function toggleModal() {
    setOpenModal(!openModal);
  }

  return (
    <>
      <DataCard testId="vehicle-auction-card">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          width="100%"
          justifyContent="space-between"
          divider={
            <StyledDivider orientation={isMobile ? 'horizontal' : 'vertical'} />
          }
        >
          <CardAuctionDetails
            auction={auction}
            handleClickOnSeeDetailsClose={toggleModal}
          />
          <CardTitleDetails auction={auction} />
        </Stack>
      </DataCard>
      <StyledModal open={openModal} onClose={toggleModal} hasCloseIcon>
        <ModalContent auction={auction} vehicleYMM={vehicleYMM} />
      </StyledModal>
    </>
  );
}
